import StoreUpdateEvents from "../constants/events/StoreUpdateEvents";
import SecureBaseStore from "./SecureBaseStore";
import UIInteractionEvents from "../constants/events/UIInteractionEvents";
import ActionResultEvents from "../constants/events/ActionResultEvents";
import SavingStates from "../constants/states/SavingStates";
import {FormFieldWithValidityState} from "./FormFieldWithValidityState";

class EmailVerificationViewState {
    constructor(
        codeCheckState,
        emailSendState,
        validationCode
    ) {
        this.codeCheckState = codeCheckState;
        this.emailSendState = emailSendState;
        this.validationCode = validationCode;
    }

    equals(other) {
        return this.codeCheckState === other.codeCheckState &&
            this.emailSendState === other.emailSendState &&
            this.validationCode.equals(other.validationCode);
    }
}

class ImmutableEmailVerificationViewStateBuilder {

    constructor() {
        this.codeCheckState = SavingStates.NOT_STARTED;
        this.emailSendState = SavingStates.NOT_STARTED;
        this.validationCode = FormFieldWithValidityState.initialDefaults("");
    }

    static fromState(state) {
        return new ImmutableEmailVerificationViewStateBuilder()
            .setCodeCheckState(state.codeCheckState)
            .setEmailSendState(state.emailSendState)
            .setValidationCode(state.validationCode.currentValue, state.validationCode.isValid, state.validationCode.isTouched)
    }

    setCodeCheckState(newState) {
        this.codeCheckState = newState;
        return this;
    }

    setEmailSendState(newState) {
        this.emailSendState = newState;
        return this;
    }

    setValidationCode(validationCode, isValid, isTouched) {
        this.validationCode = new FormFieldWithValidityState(validationCode, isValid, isTouched);
        return this;
    }

    build() {
        return Object.freeze(
            new EmailVerificationViewState(
                this.codeCheckState,
                this.emailSendState,
                this.validationCode));
    }
}


class EmailVerificationViewStore extends SecureBaseStore {

    constructor() {
        super(StoreUpdateEvents.EMAIL_VERIFICATION_VIEW_STORE_UPDATED, ImmutableEmailVerificationViewStateBuilder);
        this.subscribeToEvent(UIInteractionEvents.EMAIL_VERIFICATION_CODE_CHANGED, this.handleValidationCodeChanged);
        this.subscribeToEvent(UIInteractionEvents.EMAIL_VERIFICATION_CHECK_SUBMITTED, this.handleCheckStarted);
        this.subscribeToEvent(UIInteractionEvents.EMAIL_VERIFICATION_EMAIL_REQUESTED, this.handleEmailSendStarted);
        this.subscribeToEvent(ActionResultEvents.EMAIL_VERIFICATION_EMAIL_SENT, this.handleEmailSent);
        this.subscribeToEvent(ActionResultEvents.EMAIL_VERIFICATION_INVALID_CODE, this.handleInvalidCode);
        this.subscribeToEvent(ActionResultEvents.EMAIL_VERIFICATION_SUCCESS, this.resetStore);

    }

    handleCheckStarted = (topic, data) => {
        return ImmutableEmailVerificationViewStateBuilder.fromState(this.state)
            .setCodeCheckState(SavingStates.SAVING)
            .build();
    };

    handleEmailSendStarted = (topic, data) => {
        return ImmutableEmailVerificationViewStateBuilder.fromState(this.state)
            .setEmailSendState(SavingStates.SAVING)
            .build();
    };

    handleEmailSent = (topic, data) => {
        return ImmutableEmailVerificationViewStateBuilder.fromState(this.state)
            .setEmailSendState(SavingStates.NOT_STARTED)
            .build();
    };

    handleInvalidCode = (topic, data) => {
        return ImmutableEmailVerificationViewStateBuilder.fromState(this.state)
            .setCodeCheckState(SavingStates.FAILED_TO_SAVE)
            .setValidationCode(this.state.validationCode.currentValue, false, true)
            .build();
    };

    handleValidationCodeChanged = (topic, data) => {
        return ImmutableEmailVerificationViewStateBuilder.fromState(this.state)
            .setValidationCode(data.validationCode, data.isValid, true)
            .build();
    };


}

export default new EmailVerificationViewStore();